import React from "react";
import { Panel } from "@/components/kmt/ui";
import { FareForm } from "@/components/dash/FareForm";
import { PageTitle } from "./DashLayout";

export default function Calculator() {
  return (
    <div>
      <PageTitle title="Fare calculator" sub="Rules v3.3. Nothing is saved here. Issue locked quotes from a booking." />
      <Panel><FareForm showPickup /></Panel>
      <ul className="mt-6 grid gap-2 text-[14px] text-mist/70">
        <li>Base fare: $15 up to and including 15 miles, $30 above 15 miles.</li>
        <li>Per mile: $1.25 under 15 miles, $1.50 from 15 to 508.99 miles, $2.00 from 509 miles or for Custom Long Distance.</li>
        <li>Courtesy discount or $40 voucher, never both. Fees are added on top. Total never below $0.</li>
      </ul>
    </div>
  );
}
